
import React from "react";
import Loading from '../Helper/Loading.js'
import { apiCall } from '../Service/ConnectToServer.js';
import Swal from 'sweetalert2'

// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Col
} from "reactstrap";

function Rules() {
    const [IsLoading, setIsLoading] = React.useState(true);
    const [PageInfo, setPageInfo] = React.useState({
        Title: "",
        Body: ""
    })

    React.useEffect(() => {
        const config = {
            method: "Post",
            url: "User/GetUserSpecialPage",
            Authorization: true,
            data: {
                Slug: 'ContactUs'
            }
        }
        apiCall(config, (response) => {
            console.log(response)
            setPageInfo({
                Title: response.data.Result.Title,
                Body: response.data.Result.Text
            })
            setIsLoading(false)

        }, (err) => {
            console.log(err)
            Swal.fire({
                title: 'عملیات ناموفق',
                text: err,
                icon: 'error',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
        });
    }, []);


    return (
        <>
            <div className="content text-right">
                {IsLoading ? <Loading /> :
                    <Card className="card-info">
                        <CardHeader>
                            <strong className={CardTitle}>{PageInfo.Title}</strong>
                            <hr />
                        </CardHeader>
                        <CardBody>
                            <Col md="12">
                                <div dangerouslySetInnerHTML={{ __html: PageInfo.Body }} />
                            </Col>
                        </CardBody>
                    </Card>
                }
            </div>
        </>
    );
}

export default Rules;
